export const generalRoutes = {
  help: {
    index: '/help/help/index',
  },
  static: {
    contact: '/static/contact',
    terms_of_use: '/static/terms-of-use',
    privacy_policy: '/static/privacy-policy',
  },
  authentication: {
    login: '/auth/login',
    forgot_password: '/auth/forgot-password',
    member: {
      login: '/auth/member/login',
      confirm_otp: '/auth/member/confirm-otp',
    },
    provider: {
      login: '/auth/provider/login',
      activation: '/auth/provider/activation',
      confirm_otp: '/auth/provider/confirm-otp',
      create_password: '/auth/provider/create-password',
      reset_password: '/auth/provider/reset-password',
    },
    agent_groups: {
      login: '/auth/agent-group/login',
      activation: '/auth/agent-group/activation',
      confirm_otp: '/auth/agent-group/confirm-otp',
      create_password: '/auth/agent-group/create-password',
      reset_password: '/auth/agent-group/reset-password',
    }
  },
};
